import style from './P2PEmptyContactList.css';
import InfoOutlinedIcon from '../../shared/Icons/InfoOutlinedIcon';
import InfoTriangleIcon from '../../shared/Icons/InfoTriangleIcon';
import useTranslation from '../../../localization/i18n.context';
import Button from '../../shared/Button/Button';

export default function P2PEmptyContactList({
  className = '',
  search = '',
  onGoToSettingsButtonClick,
  permissionGranted,
}) {
  const { t } = useTranslation();

  return (
    <div className={`${style.container} ${className}`}>
      <div className={style.iconContainer}>
        {!permissionGranted ? <InfoTriangleIcon /> : <InfoOutlinedIcon />}
      </div>
      <p className={style.title}>
        {!permissionGranted
          ? t("We can't access to your contacts")
          : search.length > 0
          ? t("No results found for ':search'").replace(':search', search)
          : t("You don't have any contact")}
      </p>
      <p className={style.description}>
        {!permissionGranted
          ? t('Please go to settings and enable Connect using contacts to search within your contact list.')
          : search
          ? t("We didn't find a match! Try searching something else instead")
          : t('Send money by adding a phone number manually')}
      </p>
      {!permissionGranted && (
        <Button className={style.settings} onClick={onGoToSettingsButtonClick}>
          {t('Open settings')}
        </Button>
      )}
    </div>
  );
}
